import { useEffect, useState } from "react"
import { toast } from "react-toastify"

import { totalDataService } from "services/total/total.service"
import { YearlyStatsResponse } from "services/total/types"

type Granularity = "year" | "month" | "day" | "hour"

export const useStatsOverTime = (timeframe: (Date | null)[], tenant: string, stats: string[]) => {
  const [loading, setLoading] = useState(false)
  const [statData, setStatData] = useState<YearlyStatsResponse[]>()
  const [granularity, setGranularity] = useState<Granularity>("year")

  useEffect(() => {
    const fetchStats = async () => {
      const from = timeframe?.[0]
      const to = timeframe?.[1]
      if (!from || !to) return

      try {
        setLoading(true)

        const diffInDays = (to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24)
        let res: YearlyStatsResponse[] | undefined
        let gran: Granularity = "year"

        if (diffInDays > 730) {
          const forcedFrom = new Date("2021-01-01")
          const forcedTo = new Date()
          const qs = stats.length ? { stats: stats.join(",") } : {}
          res = await totalDataService.getStatsByYear([forcedFrom, forcedTo], qs)
          gran = "year"
        } else if (diffInDays > 31) {
          const qs = stats.length ? { stats: stats.join(",") } : {}
          res = await totalDataService.getStatsByMonth(timeframe, qs)
          gran = "month"
        } else if (diffInDays > 1) {
          const qs = stats.length ? { stats: stats.join(",") } : {}
          res = await totalDataService.getStatsByDay(timeframe, qs)
          gran = "day"
        } else {
          const qs = stats.length ? { stats: stats.join(",") } : {}
          res = await totalDataService.getStatsByHour(timeframe, qs)
          gran = "hour"
        }

        if (res) {
          setStatData(res)
          setGranularity(gran)
        }
      } catch (err: any) {
        if (err.status === 409) return
        toast.error("Failed to load time series stats")
      } finally {
        setLoading(false)
      }
    }

    if (timeframe.filter(Boolean).length === 2) {
      fetchStats()
    }
  }, [timeframe, tenant, stats])

  return { loading, data: statData, granularity }
}
